<template>
  <MainHeader></MainHeader>
  <div class="makeuser">
    <div class="title-wrapper">
      <!-- タイトルの左に戻るボタンを配置 -->
      <v-btn icon class="back-button  mt-12" @click="goBack">
        <v-icon>mdi-arrow-left</v-icon>
      </v-btn>
      <h1 class="text-center mt-12">{{ $t('editcategory.title') }}</h1>
    </div>

    <v-form ref="form">
      <v-container>
        <!-- カテゴリーの入力欄 -->
        <draggable v-model="category_list" handle=".drag-handle" @end="updateOrder">
          <template #item="{ element, index }">
            <v-row :key="element.cat_id" justify="center">
              <!-- ドラッグボタンを左側に移動 -->
              <v-col cols="1" class="align-center">
                <v-btn icon class="drag-handle">
                  <v-icon>mdi-drag</v-icon>
                </v-btn>
              </v-col>
              <v-col cols="10" sm="8" md="6">
                <v-text-field 
                  v-model="element.name" 
                  prepend-inner-icon="mdi-shape" 
                  :label="$t('makeuser.category')" 
                  variant="outlined" 
                  :rules="nameRules">
                </v-text-field>
              </v-col>
              <!-- 削除ボタンは右側に残す -->
              <v-col cols="1" class="align-center">
                <v-btn icon @click="removeCategory(index)">
                  <v-icon color="red">mdi-trash-can</v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </template>
        </draggable>

        <!-- カテゴリ追加ボタン -->
        <v-row justify="center" class="mt-4">
          <v-col cols="12" sm="6" md="4">
            <v-btn block color="primary" @click="addCategory">
              <v-icon left>mdi-plus</v-icon>
              {{ $t('editcategory.add_category') }}
            </v-btn>
          </v-col>
        </v-row>

        <!-- ボタンを下に配置し、中央に揃える -->
        <v-row justify="center" class="mt-6 mb-6">
          <v-col cols="12" sm="6" md="4">
            <!-- name が空のカテゴリがある場合、ボタンを無効化 -->
            <v-btn block color="success" @click="updatecategory" :disabled="hasEmptyCategoryName">
              {{ $t('editcategory.ok') }}
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
    </v-form>
  </div>
</template>

<script>
import MainHeader from '@/components/MainHeader.vue';
import draggable from 'vuedraggable';

export default {
  name: 'MakeUserView',
  components: {
    MainHeader,
    draggable
  },
  data() {
    return {
      nameRules: [
        v => !!v || 'カテゴリは必須です'
      ],
      category_list: [] // 必ず配列として初期化
    };
  },
  computed: {
    // 現在のカテゴリリストをストアから取得
    categoryOptions() {
      return this.$store.state.category_list;
    },
    // カテゴリ名が空のものがあるかどうかをチェック
    hasEmptyCategoryName() {
      return this.category_list.some(category => !category.name);
    }
  },
  async mounted() {
    // カテゴリリストを初期化
    this.initializeCategoryList();
  },
  methods: {
    initializeCategoryList() {
      // ストアから取得したカテゴリリストを表示用に設定
      this.category_list = [...this.categoryOptions];
    },

    // カテゴリを追加
    addCategory() {
      this.category_list.push({ order: this.category_list.length + 1, cat_id: `cat${this.category_list.length + 1}`, name: '' });
    },

    // カテゴリを削除
    removeCategory(index) {
      this.category_list.splice(index, 1);
      // 削除後、orderを更新
      this.updateOrder();
    },

    // カテゴリ順序を更新
    updateOrder() {
      this.category_list.forEach((category, index) => {
        category.order = index + 1;
      });
    },

    async updatecategory() {
      if (this.hasEmptyCategoryName) {
        alert("カテゴリ名をすべて入力してください。");
        return;
      }

      let jsonbody = {
        api_type: "updatecategory",
        user_id: this.$store.state.user_info.user_id,
        category: this.category_list  // 編集後のカテゴリリストを送信
      };

      try {
        await this.axios.post(this.$store.state.api_baseurl + "updatecategory", jsonbody, this.$store.state.post_headers);
        // カテゴリリストをストアに保存
        this.$store.commit("set_category_list", this.category_list);
        // アイテムリストページにリダイレクト
        this.$router.push({ name: "itemlist" });
      } catch (e) {
        alert(e);
      }
    },

    // 戻るボタンのメソッド
    goBack() {
      this.$router.push({ name: 'itemlist' });
    }
  }
}
</script>

<style scoped>
.makeuser {
  padding: 20px;
}

.text-center {
  text-align: center;
}

/* タイトルと戻るボタンの配置 */
.title-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
}

.back-button {
  position: absolute;
  left: 16px;
}

.v-btn {
  font-size: 16px;
}

.d-flex {
  display: flex;
  justify-content: center;
  align-items: center;
}

/* ドラッグのハンドルアイコンを追加 */
.drag-handle {
  cursor: grab;
}
</style>
